/**
 * This is the utilities
 * @type {Object}
 */
module.exports = {
    /**
     * SSO domain constants from environment variables
     */
    SSO_DOMAIN: process.env.VUE_APP_SSO_DOMAIN,
    SSO_DOMAIN_WITH_PATH: process.env.VUE_APP_SSO_DOMAIN_WITH_PATH,
    
    /**
     * Enable URL replacement flag from environment variable
     */
    ENABLE_URL_REPLACEMENT: process.env.VUE_APP_ENABLE_URL_REPLACEMENT,
    
    /**
     * URL parameter names
     */
    URL_PARAMS: {
        PRODUCT: 'product',
        ACTION: 'action',
        APP_ID: 'appId',
        RETURN_PARAM: 'returnParam',
        TOKEN: 'mttoken'
    },
    
    /**
     * Replace SSO domain in URL
     * @param {string} url - The URL to modify
     * @param {boolean} enableReplacement - Optional flag to enable/disable URL replacement
     * @return {string} The modified URL
     */
    replaceSsoDomain: function(url) {
        if (this.ENABLE_URL_REPLACEMENT === 'true') {
            return url.replace(this.SSO_DOMAIN, this.SSO_DOMAIN_WITH_PATH);
        }
        return url;
    },
    
    /**
     * Build URL with teach-web path
     * @param {string} baseUrl - The base URL to modify
     * @param {string} product - The product name
     * @param {string} action - The action parameter
     * @param {string} appId - The app ID
     * @param {string} returnParam - The return parameter
     * @param {string} token - Optional token
     * @param {boolean} enableReplacement - Optional flag to enable/disable URL replacement
     * @return {string} The constructed URL
     */
    buildTeachWebUrl: function(baseUrl, product, action, appId, returnParam, token) {
        const url = this.replaceSsoDomain(baseUrl);
        return url + `/${product}/${action}/${appId}/${returnParam}/${token ? token : ''}`;
    },
    
    /**
     * Build URL with JSON params
     * @param {string} baseUrl - The base URL
     * @param {string} product - The product name
     * @param {string} action - Optional action parameter
     * @param {string} appId - Optional app ID
     * @param {string} returnParam - Optional return parameter
     * @param {string} token - Optional token
     * @return {string} The constructed URL with JSON params
     */
    buildJsonParamsUrl: function(baseUrl, product, action, appId, returnParam, token) {
        let params = `{
            ${this.URL_PARAMS.PRODUCT}: ${product}
            ${action ? `,${this.URL_PARAMS.ACTION}: ${action}` : ''}
            ${appId ? `,${this.URL_PARAMS.APP_ID}: ${appId}` : ''}
            ${returnParam ? `,${this.URL_PARAMS.RETURN_PARAM}: ${returnParam}` : ''}
            ${token ? `,${this.URL_PARAMS.TOKEN}: ${token}` : ''}
        }`;
        const url = this.replaceSsoDomain(baseUrl);
        return url + params;
    },
    
    /**
     * Detect which app opens this web site
     * @return {Object} The app information which opens this web site
     */
    detectAppInfo: function() {
        const userAgent = window.navigator.userAgent;
        let ret = userAgent.match(/mosoteach-ios\/(\d+)/);
        if (ret != null) {
            return {
                app: 'TEACH',
                platform: 'IOS',
                buildNumber: +(ret[1])
            }
        }

        return {
            app: 'TEACH',
            platform: 'WEB',
            buildNumber: 100
        }
    }
};